/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__header */
function tpl__header() {
    var __out = '<div class="mi-detail__head mi-detail__reset"><i class="mi-detail__head-back"></i>';
    if (header__isSupportDetailSetting()) {
        __out += '<i class="mi-detail__head-detail"></i>';
    }
    __out += "</div>";
    return __out;
}

function header__isSupportDetailSetting() {
    return window.miui && window.miui.showDetailSettingDialog;
}

exports.tpl__header = tpl__header;
